import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private jwtHelper: JwtHelperService, private router: Router) {
  }
  canActivate() {
    var token = sessionStorage.getItem("jwt");
    let tokenExpiration = JSON.parse(sessionStorage.getItem('expiration'));
    let extendedExpiration = JSON.parse(sessionStorage.getItem('extendedExpiration'));
    let utcDate = new Date();

    
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      console.log("valid token " + token);
      console.log("valid token");
      //this.router.navigate(["home"]);
      return true;
    } else {
      console.log("invalid  token");
      this.router.navigate(["login"]);
      return false;
    }

  }
}
